import Vue from 'vue'
import CookieLaw from 'vue-cookie-law'

if (document.querySelectorAll('#cookie-law').length) {
  new Vue({
    el: '#cookie-law',
    components: {
      CookieLaw
    }
  })
}
